import React from "react";

export interface ExchangeTypeRenderProps {
  amount: number | string;
  fromCurrency: string;
  toCurrency: string;
}

export function ExchangeTypeRender(props: ExchangeTypeRenderProps) {
  const amount = Number(props.amount);
  return <>1 {props.fromCurrency} = {amount} {props.toCurrency}</>
}
